import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 75px;
  text-align: center;
  height: calc(100vh - 75px);
  background-color: #fff;
  /* background-color: #c4d8ff; */
`;
